import { render, staticRenderFns } from "./AddAddressGHN.vue?vue&type=template&id=a3ff8b08"
import script from "./AddAddressGHN.vue?vue&type=script&lang=ts"
export * from "./AddAddressGHN.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3ff8b08')) {
      api.createRecord('a3ff8b08', component.options)
    } else {
      api.reload('a3ff8b08', component.options)
    }
    module.hot.accept("./AddAddressGHN.vue?vue&type=template&id=a3ff8b08", function () {
      api.rerender('a3ff8b08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/components/AddAddressGHN.vue"
export default component.exports